import Select from "react-select";
import { TEt3Picker, TEt3PickerOption } from "../../../TypesNEW";
import ET3Div from "../../et3-div";
import { withLiteObserverAndTheme } from "../../et3-enhanced-render";
import Et3Text from "../../et3-text";
import { isDefinedString } from "et3-type-guards";
import { pickerEmptyValueReducer } from "../../../helpers/et3-picker-data-helper";

const Et3Picker = withLiteObserverAndTheme<TEt3Picker>((props) => {
  const {
    label,
    options,
    value,
    theme,
    isMultiple,
    style,
    containerStyle,
    width = 280,
    onChoose
  } = props;
  const { colors, unitX, unitY, getFontType, getFontSize } = theme;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={width}
      height={75}
      color={colors.all.transparent}
      style={style}
      onClick={() => {}}
    >
      {isDefinedString(label) ? (
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          fDirection="row"
          justifyContent="flex-start"
          alignItems="center"
          withShadow={false}
          width={width}
          height={30}
          color={colors.all.transparent}
          style={{}}
          onClick={() => {}}
        >
          <Et3Text
            fontFamily={"MEDIUM"}
            fontSize={18}
            text={label}
            isSpan={false}
            color={colors.all.maastrichtBlue}
            style={{
              height: 18 * unitY,
              paddingTop: 0
            }}
          />
        </ET3Div>
      ) : null}

      <ET3Div
        isScrollable={false}
        isExtendable={true}
        withShadow={true}
        width={width}
        height={45}
        fDirection="row"
        alignItems="flex-start"
        justifyContent="center"
        color={colors.all.white}
        style={{
          borderRadius: 20 * unitX,
          overflow: "hidden"
        }}
        onClick={() => {}}
      >
        <Select
          //if isMultiple is true then value should be array else will get an error
          value={pickerEmptyValueReducer(value)}
          placeholder={
            <Et3Text
              fontFamily={"LIGHT"}
              fontSize={0}
              isSpan={false}
              text={""}
              style={{}}
              color={""}
            />
          }
          onChange={(newValue: TEt3PickerOption) => {
            onChoose(pickerEmptyValueReducer(newValue));
          }}
          options={options}
          styles={{
            option: (provided) => ({
              ...provided,
              fontSize: getFontSize(25),
              color: colors.all.maastrichtBlue,
              minHeight: 40 * unitY,
              overflowWrap: "break-word",
              overflow: "hidden"
            }),

            singleValue: (provided) => ({
              ...provided,

              textAlign: "center",
              color: colors.all.maastrichtBlue,

              fontSize: getFontSize(18)
            }),
            dropdownIndicator: (base) => ({
              ...base,
              color: colors.all.white,
              fontFamily: getFontType("MEDIUM")
            }),
            indicatorsContainer: () => ({
              display: "flex",
              backgroundColor: colors.all.bondiBlue,
              width: 22 * unitX,
              height: 22 * unitY,
              borderRadius: 10 * unitX,
              justifyContent: "center",
              alignItems: "center",
              pointerEvents: "none",
              position: "absolute",
              textAlign: "center",
              right: 15,
              pointer: "none"
            }),
            control: () => ({
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              width: width * unitX,
              minHeight: 45 * unitY,
              borderRadius: 39 * unitX,
              borderColor: colors.all.transparent
            }),
            clearIndicator: () => ({
              display: "none"
            }),
            menuList: () => ({
              overflow: "scroll",
              maxHeight: 300 * unitY,
              marginBottom: 0
            }),
            // flagged description used to push the page height to include the select menu
            menu: (provided) => ({
              ...provided,
              position: "relative",
              marginBottom: 0,
              borderLeft: `1px solid ${colors.all.lightGray}`,
              borderRight: `1px solid ${colors.all.lightGray}`,
              borderBottom: `1px solid ${colors.all.lightGray}`,
              borderBottomLeftRadius: 20 * unitX,
              borderBottomRightRadius: 20 * unitX
            }),
            container: (provided) => ({
              width: "100%",
              ...provided,
              ...containerStyle
            })
          }}
          isMulti={isMultiple}
          components={
            options.some((option) => option.badge)
              ? {
                  Option: ({ children, ...props }) => (
                    <div {...props.innerProps}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          backgroundColor: props.isFocused
                            ? colors.all.dodgerBlue
                            : "transparent",
                          padding: 12 * unitX
                        }}
                      >
                        <span>{props.data.label}</span>
                        {props.data.badge > 0 && (
                          <div
                            style={{
                              backgroundColor: colors.all.red,
                              color: "white",
                              borderRadius: props.isFocused ? 3 : 20,
                              width: 50 * unitX,
                              height: 20 * unitY,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: getFontSize(12),
                              fontWeight: "bold"
                            }}
                          >
                            {props.data.badge}
                          </div>
                        )}
                      </div>
                    </div>
                  )
                }
              : undefined
          }
        />
      </ET3Div>
    </ET3Div>
  );
});
export default Et3Picker;
